// Fonction pour définir le mode par défaut selon la taille d'écran
function setDefaultViewMode() {
    const productGrid = document.getElementById('product-grid');
    const listBtn = document.querySelector('.wblistgridbtn.listv');
    const gridBtn = document.querySelector('.wblistgridbtn.gridv');
    
    if (!productGrid || !listBtn || !gridBtn) return;
    
    // En responsive (max-width: 767px), forcer le mode liste
    if (window.innerWidth <= 767) {
        // Activer le bouton liste
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        listBtn.classList.add('active');
        // Appliquer le mode liste
        productGrid.classList.add('product-list');
        productGrid.classList.remove('product-grid');
    } else {
        // Sur grand écran, garder le comportement par défaut (mode grille)
        // Vérifier si aucun bouton n'est actif, alors activer le bouton grille
        const hasActive = Array.from(document.querySelectorAll(".wblistgridbtn")).some(btn => btn.classList.contains('active'));
        if (!hasActive) {
            gridBtn.classList.add('active');
            productGrid.classList.add('product-grid');
            productGrid.classList.remove('product-list');
        }
    }
}

// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});

// Définir le mode par défaut selon la taille d'écran
setDefaultViewMode();
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// Gérer le redimensionnement de la fenêtre
window.addEventListener('resize', function() {
    // Attendre un peu pour éviter trop d'appels
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(setDefaultViewMode, 100);
});

// Appeler au chargement de la page
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setDefaultViewMode);
} else {
    setDefaultViewMode();
}

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i];
      if (thisVideoEl.closest('media-gallery')) {
        continue;
      }
      videoHeight = thisVideoEl.clientHeight,
      videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setInterval(countDown, 1000); // Start the countdown interval
  countDown(); // Initial call to display immediately

  function countDown() {
    const countCardSections = document.querySelectorAll('.countd_all');
    countCardSections.forEach((countdownSection) => {
      const countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
      const now = Date.now();
      const distance = countDownDate - now;

      const daysElement = countdownSection.querySelector('.main_cdays .wb_cdays');
      const hoursElement = countdownSection.querySelector('.main_chours .wb_chours');
      const minutesElement = countdownSection.querySelector('.main_cminutes .wb_cminutes');
      const secondsElement = countdownSection.querySelector('.main_cseconds .wb_cseconds');

      // Use countd_all as the parent context to find the message element
      const messageElement = countdownSection.querySelector('.main_ctext');

      if (distance < 0 || isNaN(countDownDate)) {
        // Timer is over
        daysElement.textContent = "00";
        hoursElement.textContent = "00";
        minutesElement.textContent = "00";
        secondsElement.textContent = "00";

        if (messageElement && messageElement.textContent.trim() !== '') {
          // If message exists
          daysElement.parentElement.style.display = "none";
          hoursElement.parentElement.style.display = "none";
          minutesElement.parentElement.style.display = "none";
          secondsElement.parentElement.style.display = "none";
          countdownSection.style.display = "inline-block"; // Show countdown section
          messageElement.style.display = "block"; // Show message
        }
      } else {
        // Update timer values
        daysElement.textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
        hoursElement.textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutesElement.textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        secondsElement.textContent = Math.floor((distance % (1000 * 60)) / 1000);
        if (messageElement) {
          messageElement.style.display = "none"; // Hide message while counting down
        }
      }
    });
  }
});

// Masquer les contrôles vidéo dans les slideshows (header de la home)
function hideVideoControls() {
  // Retirer l'attribut controls des vidéos dans les slideshows
  const slideshowVideos = document.querySelectorAll('.slideshow video, .slideshow .slideshow__media video, .slideshow .video-section__media video');
  slideshowVideos.forEach(video => {
    video.removeAttribute('controls');
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('disablepictureinpicture', 'true');
  });
}

// Appeler au chargement et lors du chargement de sections Shopify
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideVideoControls);
} else {
  hideVideoControls();
}

document.addEventListener('shopify:section:load', hideVideoControls);

